import { z } from 'zod'

export const unifiedSearchHitSchema = z.object({
  type: z.enum([
    'property',
    'ticketing_offer',
    'lottery_draw',
    'match_event',
    'group_trip',
    'partner_offer',
    'listing',
    'article',
    'page',
  ]),
  id: z.string().min(1),
  title: z.string().min(1),
  url: z.string().min(1),
})

export const unifiedSearchResponseSchema = z.object({
  data: z.array(unifiedSearchHitSchema),
})

export type UnifiedSearchHit = z.infer<typeof unifiedSearchHitSchema>
